import { EventBus } from '../api/eventbus';
import store from '../store';

export default class Sounds {
    constructor() {
        this.enabled = false;
        this.sounds = [
            {
                id:     's11',
                title:  'Wosh',
                artist: '',
                url:    'sfx/sound11.mp3'
            },
            {
                id:     'coin_1',
                title:  'Coins',
                artist: '',
                url:    'sfx/coin_1.mp3'
            },
            {
                id:     'coin_2',
                title:  'Coins',
                artist: '',
                url:    'sfx/coin_2.mp3'
            },
            {
                id:     'coin_3',
                title:  'Coins',
                artist: '',
                url:    'sfx/coin_3.mp3'
            },
            {
                id:     'coin_4',
                title:  'Coins',
                artist: '',
                url:    'sfx/coin_4.mp3'
            },
            {
                id:     'coin_5',
                title:  'Coins',
                artist: '',
                url:    'sfx/coin_5.mp3'
            },
            {
                id:     'typewriter',
                title:  'typewriter',
                artist: '',
                url:    'sfx/typewriter_1.mp3'
            },
            {
                id:     'gotit_1',
                title:  'Gotit',
                artist: '',
                url:    'sfx/you_got_it_1.mp3'
            },
            {
                id:     'gotit_2',
                title:  'Gotit',
                artist: '',
                url:    'sfx/you_got_it_2.mp3'
            },
            {
                id:     'applause',
                title:  'applause',
                artist: '',
                url:    'sfx/crowd-excited.mp3'
            },
            {
                id:     'badEvent',
                title:  'badEvent',
                artist: '',
                url:    'sfx/sound98.mp3'
            },
            {
                id:     'goodEvent',
                title:  'goodEvent',
                artist: '',
                url:    'sfx/sound106.mp3'
            }
        ];
        this.registerEvents();
    }

    registerEvents() {
        EventBus.$on('playSound', id => {
            this.play(id);
        });
        // @todo: remove enable/disable stuff?
        EventBus.$on('muteSound', () => {
            this.disable();
        });
        EventBus.$on('unMuteSound', () => {
            this.enable();
        });
    }

    play(id) {
        if (store.state.game.soundEnabled === true) {
            if (id === 'coins') {
                id = `coin_${(Math.floor(Math.random() * 5) + 1).toString()}`;
            } else if (id === 'gotit') {
                id = `gotit_${(Math.floor(Math.random() * 2) + 1).toString()}`;
            }
            let file = this.sounds.filter(sound => sound.id === id);
            if (typeof file !== 'undefined') {
                let audio = new Audio(file[0].url);
                audio.play();
                return true;
            }
        }
        return false;
    }

    enable() {
        store.commit({ type: 'UNMUTE' });
        this.enabled = true;
        return this.enabled;
    }

    disable() {
        store.commit({ type: 'MUTE' });
        this.enabled = false;
        return this.enabled;
    }

    getSounds() {
        return this.sounds;
    }

    isEnabled() {
        return this.enabled;
    }

    toggleEnabled() {
        store.commit({ type: 'TOGGLE_MUTE' });
        this.enabled = !this.enabled;
        return this.enabled;
    }
}
